import { Link, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { Helmet } from "react-helmet";
import Layout1 from '../layouts/Layout1';

export const Blog = () => {
  const { category: paramCategory } = useParams();
  const [blogs, setBlogs] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(paramCategory || 'All');
  const [uniqueCategories, setUniqueCategories] = useState(new Set());
  const [searchQuery, setSearchQuery] = useState('');

  const GetBlog = async (url) => {
    try {
      const resblog = await axios.get(url);
      setBlogs(resblog.data.data);
    } catch (err) {
      console.error("Error fetching blog data:", err);
    }
  };

  useEffect(() => {
    GetBlog('https://shop.sagetag.com/api/v2/blogs');
  }, []);

  useEffect(() => {
    if (blogs.length > 0) {
      const categories = new Set(blogs.map(blog => blog?.category?.category_name).filter(Boolean));
      setUniqueCategories(categories);
    }
  }, [blogs]);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const filteredBlogs = blogs.filter(blog => {
    const matchCategory = selectedCategory === 'All' || blog?.category?.category_name === selectedCategory;
    const matchSearch = !searchQuery || blog?.title?.toLowerCase().includes(searchQuery.toLowerCase());
    return matchCategory && matchSearch;
  });

  return (
    <Layout1>
    <>
      <Helmet>
        <title>Blogs | Silk Digitizing </title>
        <link rel="canonical" href="https://silkdigitizing.com/blogs" />
      </Helmet>

      <section className="page-banner bgs-cover text-white pt-65 pb-40" id="page-banner" style={{ backgroundImage: 'url(images/Aboutispagecover.webp)' }}>
        <div className="container">
          <div className="banner-inner mt-65">
            <h1 className="page-title wow fadeInUp delay-0-2s" style={{ color: '#000', fontSize: 'xx-large' }}>Blogs</h1>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb wow fadeInUp delay-0-4s">
                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                <li className="breadcrumb-item active">Blogs</li>
              </ol>
            </nav>
          </div>
        </div>
      </section>

      <section className="blog-standard-area py-60">
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-xl-4 col-lg-5 order-lg-1 order-2">
              <div className="blog-sidebar rmb-75">
                <div className="widget widget-search wow fadeInUp delay-0-2s">
                  <h4 className="widget-title">Search</h4>
                  <form className="default-search-form" onSubmit={(e) => e.preventDefault()}>
                    <input type="text" placeholder="Search" value={searchQuery} onChange={handleSearchChange} required />
                    <button type="submit" className="searchbutton far fa-search" />
                  </form>
                </div>

                <div className="widget widget-category wow fadeInUp delay-0-4s">
                  <h4 className="widget-title">Category</h4>
                  <ul>
                    <li>
                      <button className={selectedCategory === 'All' ? 'colorbluew' : ''} onClick={() => setSelectedCategory('All')} style={{ background: "transparent" }}>
                        ALL
                      </button>
                    </li>
                    {[...uniqueCategories].map((categoryName, index) => (
                      <li key={index}>
                        <button className={selectedCategory === categoryName ? 'colorbluew' : ''} onClick={() => setSelectedCategory(categoryName)} style={{ background: "transparent" }}>
                          {categoryName}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="widget widget-recent-post wow fadeInUp delay-0-2s">
                  <h4 className="widget-title">Recent Blogs</h4>
                  <ul>
                    {blogs.slice(0, 3).map(({ banner, id, slug, title, category }) => (
                      <li key={id + title}>
                        <div className="image">
                          <img src={banner} alt="Post" />
                        </div>
                        <div className="content">
                          <h6><Link to={`/blog/${slug}`}>{title}</Link></h6>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-lg-7 order-lg-2 order-1 blog-standardhigh">
              <div className="blog-standard-wrap">
                {filteredBlogs.map(({ banner, id, category, slug, short_description, formatted_created_at, title }) => (
                  <div className="blog-standard-item wow fadeInUp delay-0-2s" key={id + title}>
                    <div className="image">
                      <img src={banner} alt="Blog Standard" style={{ height: '22rem' }} />
                    </div>
                    <div className="content">
                      <ul className="blog-meta">
                        <li>
                          <div className="author">
                            <Link to={`/blogs/${category?.category_name}`} className="name">{category?.category_name}</Link>
                          </div>
                        </li>
                        <li><i className="far fa-calendar-alt" /> {formatted_created_at}</li>
                      </ul>
                      <h4><Link to={`/blog/${slug}`}>{title}</Link></h4>
                      <p>{short_description}</p>
                      <Link to={`/blog/${slug}`} className="read-more">Read More <i className="far fa-long-arrow-right" /></Link>
                    </div>
                  </div>
                ))}
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-area bgc-gradient">
        <div className="row">
          <div className="col-xl-4">
            <div className="cta-left-image rel z-1 wow fadeInLeft delay-0-4s">
              {/* <img src="../images/Home/apparel-and-footwear.webp" alt="CTA Left" /> */}
              <div className="circle-shapes white-shape no-animation">
                <div className="shape-inner">
                  <span className="dot-one" />
                  <span className="dot-two" />
                  <span className="dot-three" />
                  <span className="dot-four" />
                  <span className="dot-five" />
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-4 align-self-center">
            <div className="cta-content text-white py-55 wow fadeInUp delay-0-2s">
              <div className="section-title mb-35">
                <span className="sub-title mb-10">Contact With Us</span>
                <h2>Ready with a design idea? Look no further!</h2>
              </div>
              <Link to="https://www.silkdigitizing.com/cp/login.asp" className="theme-btn">
                Start Your Projects <i className="far fa-long-arrow-right" />
              </Link>
            </div>
          </div>
          <div className="col-xl-4">
            <div className="cta-right-image rel z-1 wow fadeInRight delay-0-2s">
              {/* <img src="../images/Home/girl-holding-red-patch-cap.webp" alt="CTA Right" /> */}
              <div className="circle-shapes white-shape no-animation">
                <div className="shape-inner">
                  <span className="dot-one" />
                  <span className="dot-two" />
                  <span className="dot-three" />
                  <span className="dot-four" />
                  <span className="dot-five" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </></Layout1>
  );
};
